const EntityStatus = Object.freeze({
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    ARCHIVED: 'Archived',
    DELETED: 'Deleted',

    slimValues: {
        A: 'Active',
        I: 'Inactive',
        V: 'Archived',
        D: 'Deleted',
    },
});

module.exports = EntityStatus;
